import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const disabilityOrAbsenceFromWork: AnswerPathTreeNode = {
  path: 'disabilityOrAbsenceFromWork',
  children: [
    { path: 'hadDisabilityOrAbsenceFromWork', nodeId: NodeIds.healthInsuredHadDisabilityOrAbsenceFromWork },
    {
      path: 'hadDisabilityOrAbsenceFromWorkDetails',
      nodeId: NodeIds.healthInsuredHadDisabilityOrAbsenceFromWorkDetails,
    },
  ],
};
